import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const PollNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="url(#PollNotification1)" />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.454 16.846h-2.908c-2.423 0-3.392-.97-3.392-3.392v-2.908c0-2.423.969-3.392 3.392-3.392h2.908c2.423 0 3.392.97 3.392 3.392v2.908c0 2.423-.97 3.392-3.392 3.392Zm-2.476-6.837a.35.35 0 0 0-.495-.495l-.843.843-.116-.116a.35.35 0 0 0-.495.495l.363.363a.35.35 0 0 0 .495 0l1.09-1.09Zm1.201.129a.35.35 0 1 0 0 .7h2.544a.35.35 0 1 0 0-.7H12.18Zm-1.201 3.263a.35.35 0 0 0-.495-.495l-.843.843-.116-.116a.35.35 0 0 0-.495.495l.363.363a.35.35 0 0 0 .495 0l1.09-1.09Zm1.201.13a.35.35 0 1 0 0 .7h2.544a.35.35 0 1 0 0-.7H12.18Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="PollNotification1"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#FEA65A" />
        <Stop offset="1" stopColor="#FC7815" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default PollNotification;
